/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Card_OfficialsInputs */



/**
* | output |
* | --- |
* | "Officials" |
*
* @param {Community_Card_OfficialsInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const community_card_officials = /** @type {((inputs?: Community_Card_OfficialsInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Card_OfficialsInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Officiels")
	if (locale === "es") return /** @type {LocalizedString} */ ("Oficiales")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Oficiais")
	if (locale === "it") return /** @type {LocalizedString} */ ("Ufficiali")
	return /** @type {LocalizedString} */ ("Officials")
});